<script lang="ts">
    import { z } from 'zod';

    import type { MapLayerOneType } from '../../utilities/MapLayer/MapLayerApi';
    import { MapLegendStoreZoom } from './MapLegendStore';
    import { smartRounding } from '../../components/telematics/tools/smartRounding';
    import { debug } from '../../../stores/store';

    export let layer: MapLayerOneType;

    let legend: any = null;
    let vmin: string = '';
    let vmax: string = '';

    function getLegendByZoom(zoom: number) {
        // find zoom between zmin and zmax (inclusive) - if not found, return null
        let legends = layer.params?.legend || [];
        for (let i = 0; i < legends.length; i++) {
            if (zoom >= legends[i].zmin && zoom <= legends[i].zmax) {
                return legends[i];
            }
        }
        return null;
    }

    $: {
        // legend = layer.params?.legend[0] || null;
        legend = getLegendByZoom($MapLegendStoreZoom) || null;
        vmin = legend?.vmin || '';
        vmax = legend?.vmax || '';
        if (legend) {
            if (z.coerce.number().safeParse(legend.vmin).success) {
                vmin = new smartRounding().getFormatedValue(parseFloat(legend.vmin), '', {
                    convert_nicer: true,
                });
            }
            if (z.coerce.number().safeParse(legend.vmax).success) {
                vmax = new smartRounding().getFormatedValue(parseFloat(legend.vmax), '', {
                    convert_nicer: true,
                });
            }
        }
    }
</script>

{#if layer.params && legend}
    <div class="map_legend_item_container">
        <div class="legend_icon">
            <!--            <span></span><img src="i/legend_tile.png" />-->
        </div>
        <div class="legend_value_holder">
            <div class="legend_values_title" title={layer.label}>
                {layer.label}
                {#if $debug}{$MapLegendStoreZoom}{/if}
            </div>
            <div class="legend_colors_table_holder">
                <table class="legend_colors_table">
                    <tbody>
                        <tr>
                            {#each legend.f as item}
                                <td style="background-color: {item.c}" title={item.v}></td>
                            {/each}
                        </tr>
                    </tbody>
                </table>
                <div class="legend_colors_table_border"></div>
            </div>
            <div
                style="display: flex; justify-content: space-between; align-items: center; opacity: 0.5"
            >
                <div style="display: flex; justify-content: flex-start;">{vmin}</div>
                <div style="display: flex; justify-content: flex-end;">
                    {vmax}
                </div>
            </div>
        </div>
    </div>
{/if}

<style>
    .map_legend_item_container {
        height: 52px;
        width: 100%;
        position: relative;
        display: flex;
        flex-direction: row;
        /*margin-right: 12px;*/
    }

    .legend_icon {
        height: 52px;
        display: flex;
        /*min-width: 10px;*/
    }

    /*.legend_value_holder {*/
    /*    position: absolute;*/
    /*    bottom: 0;*/
    /*    right: 0;*/
    /*}*/

    .legend_values_title {
        /*position: relative;*/
        width: 100%;
        height: 23px;
        /*color: #393939;*/
        font-size: 12px;
        line-height: 26px;
        white-space: nowrap;
        overflow: hidden !important;
        text-overflow: ellipsis;
    }

    .legend_colors_table_holder {
        height: 12px;
    }

    .legend_colors_table {
        width: 100%;
        height: 100%;
        border-collapse: collapse;
        table-layout: fixed;
    }
</style>
